var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"moudle"},[_c('div',{staticStyle:{"margin-top":"80px"}},[_c('Title',{attrs:{"title":_vm.title,"lineW":_vm.lineW,"moduleText":_vm.moduleText,"titleStyle":_vm.titleStyle}})],1),_c('div',{staticClass:"img-area"},[_c('img',{attrs:{"src":_vm.moduleImg,"alt":_vm.imgAlt,"title":_vm.imgTitle}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }